import { render, staticRenderFns } from "./dashboard_new.vue?vue&type=template&id=654a7ff6&scoped=true&"
import script from "./dashboard_new.vue?vue&type=script&lang=js&"
export * from "./dashboard_new.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_new.vue?vue&type=style&index=0&id=654a7ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654a7ff6",
  null
  
)

export default component.exports